import { $host } from "./index";

export const getAccess = async (adminId) => {
  const { data } = await $host.get(`web/access/${adminId}`);
  return data;
};

export const updateAccess = async (adminId, access) => {
  await $host.put(`web/access/${adminId}`, access);
}

export const deleteAccess = async (adminId) => {
  const { data } = await $host.delete(`web/access/${adminId}`);
  return data;
};

export const isOwner = async (adminId) => {
  const { data } = await $host.get(`web/access/isOwner/${adminId}`);
  return data.isOwner;
};